import React, { Fragment, useState, useEffect, useRef } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import Drawer from "@mui/material/Drawer";
import { Link } from "react-router-dom";
import { duration, useTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MailIcon from "@mui/icons-material/Mail";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import SchoolIcon from "@mui/icons-material/School";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import { themeStyle, themeStyleDark } from "./Components";
import HandshakeIcon from "@mui/icons-material/Handshake";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import Select from "@mui/material/Select";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AddTaskIcon from "@mui/icons-material/AddTask";
import ScrollTop from "./ScrollTop";
import Snackbar from "@mui/material/Snackbar";
import { Grid } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { CardHorizontal, SpacerH, SpacerV } from "./Hero";
import InterestsIcon from "@mui/icons-material/Interests";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AppsIcon from "@mui/icons-material/Apps";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import moment from "moment";
import { layout } from "./Layout";

const drawerWidth = 310;

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(1.8vh)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

export const CookieCordion = (props) => {
  const state = useSelector((state) => state);

  return (
    <Accordion
      expanded={props.panel === props.panelName}
      style={{
        marginTop: "30px",
        borderRadius: "15px",
        width: "100%",
      }}
    >
      <AccordionSummary
        style={{
          padding: "5px 15px 5px 15px",
          backgroundColor: themeStyle.primaryButtonColor,
          borderRadius: "5px",
          fontWeight: 600,
          height: "50px",
          color: "white",
          fontSize: "2vh",
          alignItems: "center",
        }}
        expandIcon={
          <ExpandMoreIcon
            onClick={() => {
              props.handleChangePanel(props.panelName);
            }}
            style={{ fontSize: "3.25vh", color: "white" }}
          />
        }
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            fontSize: "2vh",
            fontWeight: "bold",
          }}
        >
          {props.cookieName}
          <IOSSwitch sx={{ m: 1 }} defaultChecked />
        </div>
      </AccordionSummary>

      <AccordionDetails
        style={{
          borderBottomLeftRadius: "15px",
          borderBottomRightRadius: "15px",
          textAlign: "left",
        }}
      >
        <div
          style={{
            color: themeStyle.primaryColor,
            fontSize: layout.textSmall[state.auth.view],
            fontWeight: "bold",
            backgroundColor: "white",
          }}
        >
          {props.cookies}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

function Sidebar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const utilityNavFontSize = state.auth.isMobile
    ? layout.textSmall[state.auth.view]
    : "clamp(13px, 0.84vw, 16px)";
  const desktopNavFontSize = state.auth.isMobile
    ? layout.textSmall[state.auth.view]
    : "clamp(13px, 0.82vw, 16px)";

  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [scrollHidden, setScrollHidden] = useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const handleChangePanel = (panel) => {
    setExpanded(panel == expanded ? false : panel);
  };
  const [menuContainer, menuContainerApi] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  const [menuContainer2, menuContainerApi2] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [value, setValue] = React.useState("1");

  const [aboutContainer, aboutContainerApi] = useSpring(() => ({
    from: { opacity: 0, width: "0vw", zIndex: 2, display: "none" },
  }));

  const [cookieContainer, cookieContainerApi] = useSpring(() => ({
    from: { opacity: 0, zIndex: 999, display: "none" },
  }));

  const [cookieContainer0, cookieContainerApi0] = useSpring(() => ({
    from: { opacity: 0, zIndex: 999, display: "none", height: "0vh" },
  }));

  const [navContainer, navContainerApi] = useSpring(() => ({
    from: { transform: "translate(0px, -200px)", opacity: 0 },
    to: { transform: "translate(0px, 0px)", opacity: 1 },
    delay: props.delay,
    config: { duration: 400 },
  }));

  const menuUnderlines = useSprings(
    8,
    [0, 1, 2, 3, 4, 5, 6, 7].map((prop, index) => ({
      from: { width: "0%" },
      to: { width: activeMenu == index ? "100%" : "0%" },
    }))
  );

  // const menuUnderlinesMouseEnter = () => {
  //   menuUnderlinesApi.start({
  //     from: { width: "0%" },
  //     to: { width: "100%" },
  //   });
  // };

  // const menuUnderlinesMouseLeave = () => {
  //   menuUnderlinesApi.start({
  //     from: { width: "100%" },
  //     to: { width: "0%" },
  //   });
  // };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: drawerWidth,
    }),
  }));

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  }));

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      let direction = lastScrollY < window.scrollY ? "down" : "up";
      lastScrollY = window.scrollY;

      if (!scrollHidden) {
        if (window.scrollY > 500 && direction == "down") {
          navContainerApi.start({
            from: { transform: "translate(0px, 0px)", opacity: 0 },
            to: { transform: "translate(0px, -200px)", opacity: 1 },
            delay: props.delay,
            config: { duration: 400 },
          });
          setScrollHidden(true);
        }
      }
      if (scrollHidden) {
        if (window.scrollY > 500 && direction == "up") {
          navContainerApi.start({
            from: { transform: "translate(0px, -200px)", opacity: 0 },
            to: { transform: "translate(0px, 0px)", opacity: 1 },
            delay: props.delay,
            config: { duration: 400 },
          });
          setScrollHidden(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollHidden]);

  useEffect(() => {
    var a = localStorage.getItem("cookie_consent");
    var b = localStorage.getItem("last_viewed");

    if (a == null || a == "false") {
      if (b !== null) {
        if (moment().isAfter(moment(b).add(6, "hours"))) {
          setTimeout(() => {
            cookieContainerApi0.start({
              from: {
                opacity: 0,
                display: "none",
                zIndex: 0,
                height: "0vh",
              },
              to: {
                opacity: 1,
                display: "flex",
                zIndex: 111,
                height: state.auth.isMobile ? "20vh" : "10vh",
              },
            });
          }, 2000);
        }
      } else {
        setTimeout(() => {
          cookieContainerApi0.start({
            from: {
              opacity: 0,
              display: "none",
              zIndex: 0,
              height: "0vh",
            },
            to: {
              opacity: 1,
              display: "flex",
              zIndex: 111,
              height: state.auth.isMobile ? "20vh" : "10vh",
            },
          });
        }, 2000);
      }
    }
  }, []);

  const flagDiv = (cc, cn) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          fontSize: "2.5vh",
          cursor: "pointer",
          width: "200px",
        }}
      >
        <img
          style={{ marginRight: "15px" }}
          src={"https://flagsapi.com/" + cc + "/flat/64.png"}
        />
        <div style={{ color: "white" }}>{cn}</div>
      </div>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <ScrollTop />
      <animated.div
        className={"cookie-container0"}
        style={{
          ...cookieContainer0,
          flexDirection: state.auth.isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: state.auth.isMobile ? "stretch" : "center",
          boxSizing: "border-box",
          minHeight: state.auth.isMobile ? "168px" : "10vh",
          padding: state.auth.isMobile
            ? "10px 10px calc(10px + env(safe-area-inset-bottom))"
            : "0",
          gap: state.auth.isMobile ? "8px" : "0",
        }}
      >
        <div
          style={{
            fontSize: state.auth.isMobile ? "12px" : "1.6vh",
            lineHeight: 1.35,
            textAlign: "left",
            paddingLeft: state.auth.isMobile ? "0" : "10px",
            paddingRight: state.auth.isMobile ? "0" : "10px",
          }}
        >
          Select “Accept all” to agree to our use of cookies and similar
          technologies to enhance your browsing experience, security, analytics,
          and customization. Select “Manage” to make more choices or opt out.
        </div>
        <Grid
          container
          style={{
            width: state.auth.isMobile ? "100%" : "20%",
            paddingRight: !state.auth.isMobile ? "40px" : "0px",
            display: state.auth.isMobile ? "grid" : undefined,
            gridTemplateColumns: state.auth.isMobile
              ? "repeat(3, minmax(0, 1fr))"
              : undefined,
            columnGap: state.auth.isMobile ? "4px" : undefined,
            rowGap: state.auth.isMobile ? "6px" : "0",
          }}
        >
          <Grid
            item
            xs={4}
            md={4}
            style={
              state.auth.isMobile
                ? { minWidth: 0, width: "100%", maxWidth: "none" }
                : undefined
            }
          >
            <div
              onClick={() => {
                localStorage.setItem("cookie_consent", true);
                localStorage.setItem("last_viewed", moment());
                cookieContainerApi0.start({
                  from: {
                    display: "flex",
                    opacity: 1,
                    width: "100vw",
                    zIndex: 111,
                  },
                  to: { display: "none", opacity: 0, zIndex: 2 },
                });
                cookieContainerApi.start({
                  from: {
                    opacity: 0,
                    display: "none",
                    zIndex: 0,
                  },
                  to: {
                    opacity: 1,
                    display: "flex",
                    zIndex: 111,
                  },
                });
              }}
            >
              <button
                className="ten5"
                style={{
                  width: state.auth.isMobile ? "100%" : "auto",
                  minHeight: state.auth.isMobile ? "42px" : "auto",
                  padding: state.auth.isMobile ? "7px 4px" : "10px",
                  fontSize: state.auth.isMobile ? "12px" : "1.6vh",
                  lineHeight: 1.1,
                }}
              >
                Manage
              </button>
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            md={4}
            style={
              state.auth.isMobile
                ? { minWidth: 0, width: "100%", maxWidth: "none" }
                : undefined
            }
          >
            <div
              onClick={() => {
                localStorage.setItem("cookie_consent", false);
                localStorage.setItem("last_viewed", moment());
                cookieContainerApi0.start({
                  from: {
                    display: "flex",
                    opacity: 1,
                    width: "100vw",
                    zIndex: 111,
                  },
                  to: { display: "none", opacity: 0, width: "0vw", zIndex: 2 },
                });
              }}
            >
              <button
                className="ten5"
                style={{
                  width: state.auth.isMobile ? "100%" : "auto",
                  minHeight: state.auth.isMobile ? "42px" : "auto",
                  padding: state.auth.isMobile ? "7px 4px" : "10px",
                  fontSize: state.auth.isMobile ? "12px" : "1.6vh",
                  lineHeight: 1.1,
                }}
              >
                Decline All
              </button>
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            md={4}
            style={
              state.auth.isMobile
                ? { minWidth: 0, width: "100%", maxWidth: "none" }
                : undefined
            }
          >
            <div
              onClick={() => {
                localStorage.setItem("cookie_consent", true);
                localStorage.setItem("last_viewed", moment());
                cookieContainerApi0.start({
                  from: {
                    display: "flex",
                    opacity: 1,
                    width: "100vw",
                    zIndex: 111,
                  },
                  to: { display: "none", opacity: 0, width: "0vw", zIndex: 2 },
                });
              }}
            >
              <button
                className="ten4"
                style={{
                  width: state.auth.isMobile ? "100%" : "auto",
                  minHeight: state.auth.isMobile ? "42px" : "auto",
                  padding: state.auth.isMobile ? "7px 4px" : "10px",
                  fontSize: state.auth.isMobile ? "12px" : "1.6vh",
                  lineHeight: 1.1,
                }}
              >
                Accept All
              </button>
            </div>
          </Grid>
        </Grid>
      </animated.div>
      <animated.div
        className={"cookie-container"}
        style={{ ...cookieContainer }}
      >
        <div
          style={{
            width: state.auth.isMobile ? "100vw" : "50vw",
            height: state.auth.isMobile ? "80vh" : "60vh",
            marginTop: state.auth.isMobile ? "20px" : "100px",
            borderRadius: "5px",
            padding: "25px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "black",
            zIndex: state.auth.isMobile ? 999 : 995,
          }}
        >
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                justifyContent: "center",
                fontSize: state.auth.isMobile ? "25px" : "3vh",
                background: "transparent",
                maxWidth: "100vw",
              }}
            >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  label="Consent"
                  value="1"
                  style={{ fontSize: "15px", color: "white" }}
                />
                <Tab
                  label="Details"
                  value="2"
                  style={{ fontSize: "15px", color: "white" }}
                />
                <Tab
                  label="About"
                  value="3"
                  style={{ fontSize: "15px", color: "white" }}
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              <b style={{ color: "white", textAlign: "left", fontSize: "3vh" }}>
                This website uses cookies
              </b>
              <div
                style={{
                  color: "white",
                  textAlign: "justify",
                  marginTop: "25px",
                  fontSize: "2vh",
                }}
              >
                {" "}
                We use cookies to personalise content and ads, to provide social
                media features and to analyse our traffic. We also share
                information about your use of our site with our social media,
                advertising and analytics partners who may combine it with other
                information that you’ve provided to them or that they’ve
                collected from your use of their services.
              </div>
            </TabPanel>
            <TabPanel value="2" style={{ width: "100%" }}>
              <div style={{ width: "100%" }}>
                <CookieCordion
                  panelName={"panel1"}
                  panel={expanded}
                  handleChangePanel={handleChangePanel}
                  cookieName="Necessary"
                  cookies={
                    "Required to enable core site functionality and to remember user preferences and choices, such as language preferences or customized settings."
                  }
                />
                <CookieCordion
                  panelName={"panel2"}
                  panel={expanded}
                  handleChangePanel={handleChangePanel}
                  cookieName="Performance and Analytics"
                  cookies={
                    "These cookies provide quantitative measures of website visitors. With the usage of these cookies we are able to count visits and traffic sources to improve the performance of our site."
                  }
                />
                <CookieCordion
                  panelName={"panel3"}
                  panel={expanded}
                  handleChangePanel={handleChangePanel}
                  cookieName="Advertising"
                  cookies={
                    "These cookies are used by advertising companies to serve ads that are relevant to your interests."
                  }
                />
              </div>
            </TabPanel>{" "}
            <TabPanel value="3">
              <div
                style={{
                  color: "white",
                  fontSize: "1.75vh",
                }}
              >
                Cookies are small text files that can be used by websites to
                make a user's experience more efficient.
                <br />
                <br /> The law states that we can store cookies on your device
                if they are strictly necessary for the operation of this site.
                <br />
                <br /> For all other types of cookies we need your permission.
                This site uses different types of cookies.
                <br />
                <br /> Some cookies are placed by third party services that
                appear on our pages. You can at any time change or withdraw your
                consent from the Cookie Declaration on our website.
                <br />
              </div>
            </TabPanel>
          </TabContext>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div
              onClick={() => {
                localStorage.setItem("cookie_consent", true);
                localStorage.setItem("last_viewed", moment());
                cookieContainerApi.start({
                  from: {
                    display: "flex",
                    opacity: 1,
                    width: "100vw",
                    zIndex: 111,
                  },
                  to: { display: "none", opacity: 0, width: "0vw", zIndex: 2 },
                });
              }}
            >
              <button class="ten2">Allow</button>
            </div>
            <div
              onClick={() => {
                localStorage.setItem("cookie_consent", false);
                localStorage.setItem("last_viewed", moment());
                cookieContainerApi.start({
                  from: {
                    display: "flex",
                    opacity: 1,
                    width: "100vw",
                    zIndex: 111,
                  },
                  to: { display: "none", opacity: 0, width: "0vw", zIndex: 2 },
                });
              }}
            >
              <button class="ten3">Reject</button>
            </div>
          </div>
        </div>
      </animated.div>
      <animated.div
        onClick={() => {
          aboutContainerApi.start({
            from: { display: "flex", opacity: 1, width: "100vw", zIndex: 1111 },
            to: { display: "none", opacity: 0, width: "0vw", zIndex: 2 },
          });
        }}
        className={"about-container"}
        style={{ ...aboutContainer }}
      >
        <div style={{ position: "fixed", top: 200, right: 200 }}>
          <CloseIcon
            style={{
              fontSize: state.auth.isMobile ? "30px" : "4.4vh",
              color: "white",
              cursor: "pointer",
            }}
          />
        </div>
        <div
          style={{
            width: "50vw",
            marginTop: "100px",
            backgroundColor: "white",
            borderRadius: "25px",
            padding: "25px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={require("../img/footor-logo.png")}
            style={{ height: "50px", marginTop: "15px" }}
            alt="Riches Media Digital Logo"
          />{" "}
          <br />
          <div style={{ color: "black" }}>
            <div style={{ fontWeight: "bold", fontSize: "22px" }}>
              Founded in India, presence in more than 2+ countries
            </div>
            <div style={{ fontSize: "2.2vh" }}>
              Building and delivering globally proven solutions optimized for
              each unique local market.
            </div>
            <br />
            <br />
            <div style={{ fontSize: "26px" }}>
              301 NJ-17, Rutherford, NJ 07070, United States{" "}
            </div>
            <br />
            <div style={{ fontWeight: "bold", color: themeStyle.primaryColor }}>
              Email: letstalk@richesmediadigital.com{" "}
            </div>
            <div style={{ fontWeight: "bold", color: themeStyle.primaryColor }}>
              Contact: +1 201 456 2171
            </div>
            <br />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <a
                href="https://x.com/richesmediadigital"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px black solid",
                  borderRadius: "40px",
                  width: "50px",
                  height: "50px",
                  fontSize: "2.5vh",
                  color: "white",
                  marginRight: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <XIcon style={{ color: "black", fontSize: "30px" }} />
              </a>
              <a
                href="https://in.linkedin.com/company/richesmediadigital"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px black solid",
                  borderRadius: "40px",
                  width: "50px",
                  height: "50px",
                  fontSize: "2.5vh",
                  color: "white",
                  marginRight: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <LinkedInIcon style={{ color: "black", fontSize: "30px" }} />
              </a>

              <a
                href="https://www.facebook.com/Richesmediadigital/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px black solid",
                  borderRadius: "40px",
                  width: "50px",
                  height: "50px",
                  fontSize: "2.5vh",
                  color: "white",
                  marginRight: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <FacebookIcon style={{ color: "black", fontSize: "30px" }} />
              </a>
              <a
                href="https://www.instagram.com/richesmediadigital/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px black solid",
                  borderRadius: "40px",
                  width: "50px",
                  height: "50px",
                  fontSize: "2.5vh",
                  color: "white",
                  marginRight: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <InstagramIcon style={{ color: "black", fontSize: "30px" }} />
              </a>
            </div>
          </div>
        </div>
      </animated.div>

      <Snackbar
        open={state.auth.alert != null ? true : false}
        autoHideDuration={6000}
        onClose={() => dispatch({ type: "REMOVE_ALERT" })}
        message={state.auth.alert == null ? "" : state.auth.alert.message}
        action={
          <div
            onClick={() => dispatch({ type: "REMOVE_ALERT" })}
            style={{ padding: "2px", cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        }
      />

      <div
        onMouseEnter={() => {
          if (scrollHidden) {
            navContainerApi.start({
              from: { transform: "translate(0px, -200px)", opacity: 0 },
              to: { transform: "translate(0px, 0px)", opacity: 1 },
              delay: props.delay,
              config: { duration: 400 },
            });
            setScrollHidden(false);
          }
        }}
        style={{
          height: "150px",
          width: "100vw",
          position: "fixed",
          zIndex: 1000,
        }}
      ></div>

      <AppBar
        position="fixed"
        open={open}
        elevation={0}
        sx={{
          bgcolor: "transparent",
        }}
      >
        <animated.div
          id="nav-bar"
          style={{
            padding: state.auth.isMobile ? "5px" : "0px 25px 0px 25px",
            width: "100%",
            backdropFilter: "blur(15px)",
            backgroundColor: "rgba(0,0,0,0.6)",
            borderBottom: "1px solid #666",
            ...navContainer,
          }}
        >
          {state.auth.isMobile ? (
            <div
              style={{
                fontSize: layout.textSmall[state.auth.view],
                textAlign: "center",
                width: "100%",
                marginBottom: "5px",
              }}
            >
              Revenue driven for our Clients:<b>$54 Million +</b>
            </div>
          ) : (
            ""
          )}
          <div
            style={{
              width: "100%",
              minHeight: state.auth.isMobile ? "auto" : "42px",
              height: state.auth.isMobile ? "auto" : "42px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "18px",
              lineHeight: 1.2,
            }}
          >
            {!state.auth.isMobile ? (
              <div
                style={{
                  fontSize: utilityNavFontSize,
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Revenue driven for our Clients:<b>$54 Million +</b>
              </div>
            ) : (
              <div>
                <a
                  href="tel:+12014562171"
                  style={{
                    cursor: "pointer",
                    fontSize: utilityNavFontSize,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    marginRight: "0px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <PhoneInTalkIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: state.auth.isMobile ? "5px" : "15px",
                    }}
                  />{" "}
                  +1 201 456 2171
                </a>
              </div>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: state.auth.isMobile ? "12px" : "clamp(18px, 2vw, 32px)",
                minWidth: 0,
                flexShrink: 0,
              }}
            >
              {state.auth.isMobile || state.auth.view == "TABP" ? (
                ""
              ) : (
                <a
                  href="tel:+12014562171"
                  style={{
                    cursor: "pointer",
                    fontSize: utilityNavFontSize,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    marginRight: "0px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <PhoneInTalkIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  +1 201 456 2171
                </a>
              )}
              {state.auth.isMobile ? (
                ""
              ) : (
                <a
                  href="mailto:letstalk@richesmediadigital.com"
                  style={{
                    cursor: "pointer",
                    fontSize: utilityNavFontSize,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    marginRight: "0px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <EmailIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  letstalk@richesmediadigital.com
                </a>
              )}

              <Link
                to="/get-a-quote/"
                style={{
                  padding: "5px",
                  width:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "30vw"
                      : "clamp(220px, 16vw, 300px)",
                  height: state.auth.isMobile ? "42px" : "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "5px",
                  color: "white",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: utilityNavFontSize,
                  lineHeight: 1,
                  whiteSpace: "nowrap",
                }}
                className="nav-item anigrad"
              >
                {state.auth.isMobile
                  ? "Get Proposal"
                  : "GET YOUR FREE PROPOSAL"}
              </Link>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              minHeight: state.auth.isMobile ? "76px" : "68px",
            }}
          >
            <Link
              style={{
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={"/"}
            >
              <img
                src={require("../img/logo.png")}
                alt={"Riches Media Digital Logo"}
                style={{
                  height: "50px",
                  marginTop: state.auth.isMobile ? "15px" : "8px",
                  marginBottom: state.auth.isMobile ? "10px" : "8px",
                }}
              />
            </Link>
            <div>
              {state.auth.isMobile || state.auth.view == "TABP" ? (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={handleDrawerOpen}
                  sx={{ ...(open && { display: "none" }) }}
                >
                  <MenuIcon style={{ marginLeft: "-100px" }} />
                </IconButton>
              ) : (
                <div
                  style={{
                    display:
                      state.auth.isMobile || state.auth.view == "TABP"
                        ? "none"
                        : "flex",
                    alignItems: "center",
                    fontSize: desktopNavFontSize,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      <Link
                        to="/digital-marketing/"
                        style={{
                          width: "clamp(148px, 10vw, 180px)",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(1);
                          menuContainerApi.start({
                            from: { opacity: 0, display: "none" },
                            to: { opacity: 1, display: "block" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Digital Marketing
                        <KeyboardArrowDownIcon
                          className="nav-icon"
                          style={{
                            fontSize: 20,
                            marginLeft: "5px",
                          }}
                        />
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[1]}
                      />
                    </div>
                    <div>
                      <Link
                        to="/web-design/"
                        style={{
                          width: "clamp(140px, 9.5vw, 170px)",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(2);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 0, display: "none" },
                            to: { opacity: 1, display: "block" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Design Services
                        <KeyboardArrowDownIcon
                          className="nav-icon"
                          style={{
                            fontSize: 20,
                            marginLeft: "5px",
                          }}
                        />
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[2]}
                      />
                    </div>
                    <div>
                      <Link
                        to="/casestudies/"
                        style={{
                          width: "clamp(118px, 8vw, 145px)",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(3);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Case Studies
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[3]}
                      />
                    </div>
                    <div>
                      <Link
                        to="/careers/"
                        style={{
                          width: "clamp(78px, 5.8vw, 104px)",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(4);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Careers
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[4]}
                      />
                    </div>
                    <div>
                      <Link
                        to="/about-us/"
                        style={{
                          width: "clamp(92px, 6vw, 112px)",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(5);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        About Us
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[5]}
                      />
                    </div>
                    <div>
                      <Link
                        to="/blog/"
                        style={{
                          width: "72px",
                          textDecoration: "none",
                          color: "white",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(6);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Blog
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[6]}
                      />
                    </div>

                    <div>
                      <Link
                        to="/contact-us/"
                        style={{
                          width: "clamp(126px, 8vw, 150px)",
                          border: "1px solid white",
                          borderRadius: "90px",
                          color: "white",
                          textDecoration: "none",
                        }}
                        className="nav-item"
                        onMouseEnter={() => {
                          setActiveMenu(7);
                          menuContainerApi.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                          menuContainerApi2.start({
                            from: { opacity: 1, display: "block" },
                            to: { opacity: 0, display: "none" },
                          });
                        }}
                        onMouseLeave={() => {
                          setActiveMenu(10);
                        }}
                      >
                        Contact Us
                      </Link>
                      <animated.div
                        key={1}
                        className="nav-underline"
                        style={menuUnderlines[7]}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <animated.div
              onMouseLeave={() => {
                menuContainerApi2.start({
                  from: { opacity: 1, display: "block" },
                  to: { opacity: 0 },
                });
                setTimeout(
                  () =>
                    menuContainerApi2.start({
                      from: { opacity: 0, display: "block" },
                      to: { opacity: 0, display: "none" },
                    }),
                  500
                );
              }}
              style={{ ...menuContainer2 }}
              id="menu-container2"
              className="menu-open-container2"
            >
              <div
                style={{
                  textAlign: "left",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Web design
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate={"web-design"}
                      title={"Wordpress Websites Design"}
                      subtitle={"Custom Websites Tailored to Your Needs"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"web-design"}
                      title={"React JS Websites"}
                      subtitle={"Modern Web Solutions with React"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"web-design"}
                      title={"Website Maintenance"}
                      subtitle={"Ensuring Optimal Website Performance"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginTop: "10px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                E-Commerce
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate={"e-commerce"}
                      title={"Shopify Store"}
                      subtitle={"Build and Manage Your Online Store"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"e-commerce"}
                      title={"E-Commerce Mobile Apps"}
                      subtitle={"Mobile Solutions for Your Online Store"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"e-commerce"}
                      title={"Dropshipping"}
                      subtitle={"Start Your E-Commerce Business"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>

              <div
                style={{
                  textAlign: "left",
                  marginTop: "10px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Mobile App design
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate={"mobile-application-development"}
                      title={"Cross Platform Hybrid Apps"}
                      subtitle={"Reach More Users with One Codebase"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"mobile-application-development"}
                      title={"Playstore/Appstore Deployment"}
                      subtitle={"Launch Your App on Major Platforms"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"mobile-application-development"}
                      title={"Integration Testing"}
                      subtitle={"Ensure Your App Works"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>

              <div
                style={{
                  textAlign: "left",
                  marginTop: "10px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                UI/UX Design
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate={"uiux"}
                      title={"UI Design"}
                      subtitle={"Intuitive and Engaging Interfaces"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"uiux"}
                      title={"UX Design"}
                      subtitle={"Creating Seamless User Experiences"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    {" "}
                    <CardHorizontal
                      navigate={"uiux"}
                      title={"Prototyping"}
                      subtitle={"Visualize and Test Your Ideas"}
                      content={
                        <AdsClickIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </animated.div>

            <animated.div
              onMouseLeave={() => {
                menuContainerApi.start({
                  from: { opacity: 1, display: "block" },
                  to: { opacity: 0 },
                });
                setTimeout(
                  () =>
                    menuContainerApi.start({
                      from: { opacity: 0, display: "block" },
                      to: { opacity: 0, display: "none" },
                    }),
                  500
                );
              }}
              style={{ ...menuContainer }}
              id="menu-container"
              className="menu-open-container"
            >
              <div
                style={{
                  textAlign: "left",
                  marginTop: "0px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Paid Ads and Monetization
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="programmatic-advertising"
                      title="Programmatic Advertising"
                      subtitle="Automated ad buying"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="ad-operations"
                      title="Ad Operations"
                      subtitle="Managing ad campaigns"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="pay-per-click"
                      title="Pay Per Click"
                      subtitle="Advertising model based on clicks"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginTop: "30px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                SEO and Social
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="search-engine-optimization"
                      title="Search Engine Optimization"
                      subtitle="Improving website visibility"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="publishers-management"
                      title="Publishers Management"
                      subtitle="Managing relationships with publishers"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="social-media-management"
                      title="Social Media Management"
                      subtitle="Your Social media presence"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>

              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="branding"
                      title="Branding"
                      subtitle="Building a strong brand identity"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="conversion-rate-optimization"
                      title="Conversion Rate Optimization"
                      subtitle="Improving website conversion and UX"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginTop: "30px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Analytics and Data
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="end-to-end-analytics"
                      title="End-to-end Analytics"
                      subtitle="Comprehensive analysis"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="data-visualization"
                      title="Data Visualization"
                      subtitle="Complete Data Insights"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="google-analytics-setup"
                      title="Google Analytics Setup"
                      subtitle="Setting up Analytics for insights"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginTop: "30px",
                  marginLeft: "15px",
                  borderRadius: "25px",
                  fontSize: "2.5vh",
                  color: themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Content Creation
              </div>
              <div style={{ display: "flex", marginBottom: "15px" }}>
                <Grid
                  container
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="video-production"
                      title="Video Production"
                      subtitle="Creating video content for campaigns"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid md={4}>
                    <CardHorizontal
                      navigate="content-marketing"
                      title="Content Marketing"
                      subtitle="Developing and distributing content"
                      content={
                        <InterestsIcon
                          style={{
                            fontSize: "3.25vh",
                            color: themeStyle.primaryColor,
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </animated.div>
          </div>
        </animated.div>
      </AppBar>

      {state.auth.isMobile || state.auth.view == "TABP" ? (
        <Drawer variant="temporary" anchor="left" open={open}>
          <DrawerHeader
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "75vw",
            }}
          >
            <Link
              style={{
                marginTop: "15px",
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={"/"}
            >
              <img
                src={require("../img/footor-logo.png")}
                style={{ height: "50px", marginTop: "15px" }}
                alt="Riches Media Digital Logo"
              />
            </Link>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </DrawerHeader>
          <List>
            <div
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
              }}
            >
              <Select
                sx={{
                  padding: "0px",
                  height: "2.2vh",
                  color: "black",
                  borderRadius: "50px",
                  borderColor: "blue",
                  fontSize: "22px",
                  fontWeight: 600,
                  marginLeft: "-5px",
                  fontFamily: "Karla",
                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover": {
                    "&& fieldset": {
                      backgroundColor: "transparent",
                    },
                  },
                }}
                value={"Digital Marketing"}
                onChange={(e) => {
                  navigate(e.target.value);
                }}
              >
                <MenuItem
                  disabled
                  value="Digital Marketing"
                  style={{
                    fontFamily: "Karla",
                    display: "none",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Digital Marketing
                </MenuItem>

                <Link
                  to="/programmatic-advertising/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/programmatic-advertising"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Programmatic Advertising
                  </MenuItem>
                </Link>

                <Link
                  to="/ad-operations/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/ad-operations"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Ad Operations
                  </MenuItem>
                </Link>

                <Link
                  to="/pay-per-click/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/pay-per-click"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Pay Per Click
                  </MenuItem>
                </Link>

                <Link
                  to="/search-engine-optimization/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/search-engine-optimization"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    SEO
                  </MenuItem>
                </Link>

                <Link
                  to="/publishers-management/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/publishers-management"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Publishers Management
                  </MenuItem>
                </Link>

                <Link
                  to="/social-media-management/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/social-media-management"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Social Media Management
                  </MenuItem>
                </Link>

                <Link
                  to="/branding/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/branding"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Branding
                  </MenuItem>
                </Link>

                <Link
                  to="/conversion-rate-optimization/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/conversion-rate-optimization"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Conversion Rate Optimization
                  </MenuItem>
                </Link>

                <Link
                  to="/end-to-end-analytics/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/end-to-end-analytics"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    End To End Analytics
                  </MenuItem>
                </Link>

                <Link
                  to="/data-visualization/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/data-visualization"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Data Visualization
                  </MenuItem>
                </Link>

                <Link
                  to="/google-analytics-setup/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/google-analytics-setup"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Google Analytics
                  </MenuItem>
                </Link>

                <Link
                  to="/video-production/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/video-production"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Video Production
                  </MenuItem>
                </Link>

                <Link
                  to="/content-marketing/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/content-marketing"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Content Marketing
                  </MenuItem>
                </Link>
              </Select>
            </div>

            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

            <div
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
              }}
            >
              <Select
                sx={{
                  padding: "0px",
                  height: "2.2vh",
                  color: "black",
                  borderRadius: "50px",
                  borderColor: "blue",
                  fontFamily: "Karla",
                  fontSize: "22px",
                  fontWeight: "600",
                  marginLeft: "-5px",
                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover": {
                    "&& fieldset": {
                      backgroundColor: "transparent",
                    },
                  },
                }}
                value={"Design Services"}
                onChange={(e) => {
                  navigate(e.target.value);
                }}
              >
                <MenuItem
                  disabled
                  value="Design Services"
                  style={{
                    fontFamily: "Karla",
                    display: "none",
                  }}
                >
                  Design Services
                </MenuItem>

                <Link
                  to="/web-design/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/web-design"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Web Design
                  </MenuItem>
                </Link>

                <Link
                  to="/mobile-application-development/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/mobile-application-development"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Mobile App
                  </MenuItem>
                </Link>

                <Link
                  to="/e-commerce/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/e-commerce"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    Ecommerce
                  </MenuItem>
                </Link>

                <Link
                  to="/uiux/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    className="nav-menu-item"
                    value="/uiux"
                    style={{ fontFamily: "Karla", fontWeight: "600" }}
                  >
                    UI/UX Design
                  </MenuItem>
                </Link>
              </Select>
            </div>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

            <Link
              to="/contact-us/"
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: "black",
                textDecoration: "none",
              }}
            >
              Contact Us
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

            <Link
              to="/careers/"
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: "black",
                textDecoration: "none",
              }}
            >
              Careers
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <Link
              to="/about-us/"
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: "black",
                textDecoration: "none",
              }}
            >
              About Us
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <Link
              to="/casestudies/"
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: "black",
                textDecoration: "none",
              }}
            >
              Case Studies
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

            <Link
              to="/blog/"
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: "black",
                textDecoration: "none",
              }}
            >
              Blog
            </Link>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
          </List>
        </Drawer>
      ) : (
        <Fragment></Fragment>
      )}
    </Box>
  );
}

export default Sidebar;
